<template>
  <div
    class="tr-select"
    :class="[{ 'position-inherit': elementTopPosition ? false : true }]"
    :style="setTrSelectStyle()"
  >
    <b-form-select
      v-model="selectVal"
      size="lg"
      :disabled="trSelectValue.block === true"
      @change="emitNewValue($event)"
      @click.native="resetCheckStatus"
      :class="[
        { 'inline-input-disabled': trSelectValue.block === true },
        { 'inline-input-correct': trSelectValue.inputStatus === 'correct' },
        { 'inline-input-wrong': trSelectValue.inputStatus === 'incorrect' },
        { 'inline-input-text-aling-center': elementTextAlign === 'center' },
        { 'inline-input-text-aling-left': elementTextAlign === 'left' },
        { 'inline-input-text-aling-right': elementTextAlign === 'right' },
      ]"
    >
      <option :value="option" class="option-style" v-for="(option, index) in options" :key="index">
        {{ option.text }}
      </option>
    </b-form-select>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtilsV2';
export default {
  name: 'tr-select-v2',
  components: {},
  props: {
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
    trSelectValue: {
      type: Object,
      default: function () {
        return {};
      },
    },
    offsetHorizontal: {
      type: Number,
      default: 0,
    },
    offsetVertical: {
      type: Number,
      default: 0,
    },
    inputWidth: {
      type: null,
      default: '',
    },
    inputHeight: {
      type: null,
      default: '',
    },
    maxLength: {
      type: null,
      default: 255,
    },
    inputFontSize: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      text: '',
    };
  },
  created() {},
  mounted() {},
  methods: {
    emitNewValue(value) {
      // // console.log( 'value', value );
      this.$emit('change', value);
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    setTrSelectStyle() {
      return `top:${this.elementTopPosition};
              left:${this.elementLeftPosition};
              width:${this.elementWidth};
              height:${this.elementHeight};`;
    },
  },
  computed: {
    selectVal: {
      get() {
        return this.trSelectValue.val;
      },
      set(newValue) {
        if (!this.trSelectValue.block) {
          this.trSelectValue.val = newValue;
        }
      },
    },
    elementTopPosition() {
      return this.config && this.config.pos
        ? utils.elementTopPosition(this.config.pos.y || 0, this.offsetVertical)
        : undefined;
    },
    elementLeftPosition() {
      return this.config && this.config.pos
        ? utils.elementLeftPosition(this.config.pos.x || 0, this.offsetHorizontal)
        : undefined;
    },
    elementWidth() {
      return utils.elementWidth(this.inputWidth);
    },
    elementHeight() {
      return utils.elementHeight(this.inputHeight);
    },
    elementTextAlign() {
      let align = 'center';
      if (this.config && this.config.align) {
        align = this.config.align;
      }
      return align;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
// @import '~@/assets/sass/inputBase';
$inlineInputwrongColor: rgb(196, 29, 29);
$inputTextColor: rgb(0, 0, 0);
$inputTextBackgroundColor: rgb(255, 255, 255);
$inputTextDisabled: rgb(235, 235, 235);
$input3DShadow: rgb(179, 179, 179);
.inline-input {
  display: inline-flex;
  color: $inputTextColor !important;
  background-color: $inputTextBackgroundColor;
  // box-shadow: inset 0 0 10px 0 $input3DShadow !important;
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: baseline;
  &:focus {
    color: $inputTextColor;
    outline: none;
  }
}
.inline-input-wrong {
  background-color: rgba($inlineInputwrongColor, 0.1) !important;
  color: $inlineInputwrongColor !important;
}
.inline-input-disabled {
  user-select: none;
  background-color: $inputTextDisabled;
}
.inline-input-correct {
  color: $inputTextColor;
  // box-shadow: inset 0 0 10px 0 $firstIconColor !important;
  background-color: rgba($firstIconColor, 0.6) !important;
}
.tr-input-text {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0.2%;
  text-align: center;
}
.inline-input-text-aling-center {
  text-align: center;
}
.inline-input-text-aling-left {
  text-align: left;
}
.inline-input-text-aling-right {
  text-align: right;
}
.tr-select {
  display: inline-flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  background-color: $bacgroundColor;
  select {
    background-size: 20px 27px;
  }
  .form-control {
    font-size: 35px !important;
    height: 70px !important;
    option {
      // width: 1.5em !important;
      font-size: 22px !important;
    }
  }
}

.position-inherit {
  position: inherit;
}
.custom-select {
  // background-color: #fff;
  // background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E");
  // background-position-x: right 0.75rem;
  // background-position-y: center;
  background-image: url("data:image/svg+xml;charset=utf8,<svg xmlns='http://www.w3.org/2000/svg'  xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='20' height='20' transform='rotate(180 10 10)' viewBox='0 0 20 20'><path fill='#000000' d='M1,17H20L10,2' /></svg>");
  background-position-x: right 2px;
  // background-position-y: center;
  background-position-y: 75%;
  // background-size: 8px 10px;
  background-repeat-x: no-repeat;
  background-repeat-y: no-repeat;
  background-color: rgb(255, 255, 255);
}
</style>
